export default function isRemote(src) {
  return src.indexOf('//') !== -1;
}
